export enum PageSizes  {
    small = 30,
    medium = 20,
    large = 30
}